import React from "react";
import GenericForm from "./GenericForm";
import StringInput from "../formElements/StringInput";
import FileUpload from "../formElements/FileUpload";
import ChangeCheckContext from "../support/ChangeCheckContext";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

function CompanySetupForm(props) {

    const [fileData, setFileData] = React.useState(null);
    const [fileNew, setFileNew] = React.useState(false);
    const {disable} = React.useContext(ChangeCheckContext)

    function customSubmit(data) {
        const formData = new FormData();
        formData.append('data', data);
        if (fileNew === true) {
            formData.append(`file`, fileData["file"]);
        }
        return formData
    }

    function parseFromData(data, commonParseFromData) {
        data.Prilohy = []
        data = commonParseFromData(data)
        if (fileNew === false) {
            data.Prilohy = fileData
        }
        return data
    }

    function newFilesUpload(files, fileData) {
        let newFile = fileData;
        let pendingReads = files.length;

        files.forEach((file) => {
            const newFileData = {newFile: true, file: file, print: false, image: ""};

            if (newFileData.file && newFileData.file.type.match('image.*')) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    newFileData.image = e.target.result
                    newFile = newFileData;
                    pendingReads -= 1;

                    // When all pending reads are complete, update the state.
                    if (pendingReads === 0) {
                        finalizeUpload(newFile);
                    }
                };
                reader.readAsDataURL(newFileData.file);
            } else {
                newFile = newFileData;
                pendingReads -= 1;

                // When all pending reads are complete, update the state.
                if (pendingReads === 0) {
                    finalizeUpload(newFile);
                }
            }
        });
    }

    function finalizeUpload(newFile) {
        setFileData(newFile);
        setFileNew(true);
    }

    function formContent(data, update) {

        function getImageSource() {
            if (fileNew) {
                return fileData['image']
            } else {
                let newFileData = {file: data.Logo}
                return data.Logo
            }
        }

        return (
            <>
                <Form.Label htmlFor="basic-url">Logo</Form.Label>
                {fileNew || data.Logo ?
                    <InputGroup className="mb-3">
                        <img src={getImageSource()} alt="" style={{height: "100px", width: "300px"}}/>
                    </InputGroup>
                    :
                    <></>
                }
                <div disabled={disable} className="mb-3 mt-3">
                    <FileUpload newFilesUpload={newFilesUpload}
                                fileData={fileData}/>
                </div>
                <StringInput name={'Meno'} label={'Meno'} value={data.Meno} onChange={update}/>
                <StringInput name={'Mesto'} label={'Mesto'} value={data.Mesto} onChange={update}/>
                <StringInput name={'Ulica'} label={'Ulica'} value={data.Ulica} onChange={update}/>
                <StringInput name={'PopisneCislo'} label={'Popisné Číslo'} value={data.PopisneCislo} onChange={update}/>
                <StringInput name={'PSC'} label={'PSČ'} value={data.PSC} onChange={update}/>
                <StringInput name={'ICO'} label={'IČO'} value={data.ICO} onChange={update}/>
                <StringInput name={'Email'} label={'E-mail'} value={data.Email} onChange={update}/>
                <StringInput name={'Fax'} label={'Fax'} value={data.Fax} onChange={update}/>
                <StringInput name={'Telefon'} label={'Telefón'} value={data.Telefon} onChange={update}/>
            </>
        )
    }

    return (
        <GenericForm label="Údaje o firme"
                     baseUrl='/own_company/own_company/'
                     formContent={formContent}
                     customSubmit={customSubmit}
                     parseFromData={parseFromData}
                     contentType={'multipart/form-data'}
                     id={1}
        />

    );
}

export default CompanySetupForm;